// import axios from 'axios';
import axios from '../../axios-orders';
import * as actionTypes from './actionTypes';

/* const getErrorMessage = (message) => {
	switch (message) {
		case 'EMAIL_EXISTS':
			return { code: 400, message: 'User with this email already exists.' };
		case 'OPERATION_NOT_ALLOWED':
			return { code: 400, message: 'This operation is not allowed.' };
		case 'TOO_MANY_ATTEMPTS_TRY_LATER':
			return { code: 400, message: 'Too many attempts, Try again Later!' };
		case 'WEAK_PASSWORD : Password should be at least 6 characters':
			return {
				code: 400,
				message: 'Weak Password, Password should be at least 6 characters!',
			};
		case 'EMAIL_NOT_FOUND':
			return {
				code: 400,
				message: 'No user exists with this Email.',
			};
		case 'INVALID_PASSWORD':
			return {
				code: 400,
				message: 'Invalid Password.',
			};
		case 'USER_DISABLED':
			return {
				code: 400,
				message: 'This account has been disabled.',
			};
		default:
			return { code: 400, message: 'Some error ocurred' };
	}
}; */

export const authStarted = () => {
	return {
		type: actionTypes.AUTH_START,
	};
};

export const authSuccess = (idToken, userId) => {
	return {
		type: actionTypes.AUTH_SUCCESS,
		idToken: idToken,
		userId: userId,
	};
};

export const authError = (error) => {
	return {
		type: actionTypes.AUTH_ERROR,
		error: error,
	};
};

export const logout = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('userId');
	localStorage.removeItem('expirationDate');
	return {
		type: actionTypes.AUTH_LOGOUT,
	};
};

export const checkAuthTimeout = (expirationTime) => {
	return (dispatch) => {
		setTimeout(() => {
			dispatch(logout());
		}, expirationTime * 1000);
	};
};

export const auth = (userData, isSignup) => {
	return (dispatch) => {
		dispatch(authStarted());
		const authData = {
			...userData,
		};
		const url = isSignup ? 'user/signup' : 'user/login';
		axios
			.post(url, authData)
			.then((res) => {
				// console.log(res);

				const expirationDate = new Date(
					new Date().getTime() + 60 * 60 * 1000
				).toISOString();
				localStorage.setItem('token', res.data.token);
				localStorage.setItem('userId', res.data.userId);
				localStorage.setItem('expirationDate', expirationDate);
				dispatch(authSuccess(res.data.token, res.data.userId));
				dispatch(checkAuthTimeout(60 * 60));
			})
			.catch((err) => {
				// The way firebase error message works
				console.log(err.response);
				// dispatch(authError(getErrorMessage(err.response.data.message)));
				dispatch(authError(err.response.data));
			});
	};
};

export const setAuthRedirectPath = (path) => {
	return {
		type: actionTypes.SET_AUTH_REDIRECT_PATH,
		path: path,
	};
};

export const authCheckState = () => {
	return (dispatch) => {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		if (!token || !userId) {
			dispatch(logout());
		} else {
			const expirationDate = new Date(localStorage.getItem('expirationDate'));
			if (expirationDate <= new Date()) {
				dispatch(logout());
			} else {
				const expirationTime = expirationDate.getTime() - new Date().getTime();
				// console.log(expirationTime);
				dispatch(authSuccess(token, userId));
				dispatch(checkAuthTimeout(expirationTime / 1000));
			}
		}
	};
};
